import React, { useEffect } from "react"
import { FormProvider, SubmitHandler, useForm } from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup';
import CpntForm from "../../../components/forms/CpntForm";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import TextInput from "../../../components/forms/TextInput";
import { validationMode } from "../../../config/helpers";
import { Button } from "react-bootstrap";
import CpntFormSectionNavigation from "../../../components/forms/CpntFormSectionNavigation";
import { useCompteChangeLoginEnvoiMailBOMutation, useFetchBOCompteQuery } from "../../../redux/slice/api/BO/compteApi";
import { toast } from "react-toastify";
import { IEmail } from "../../../models/interfaces/IEmail";
import { EmailSchema } from "../../../models/schema/emailSchema";
//import keycloak from "../../../keycloak";
//import { resetCompte } from "../../../redux/slice/compte.slice";
import { useKeycloak } from "@react-keycloak/web";
import { useNavigate, useParams } from "react-router-dom";
import { useLazyCompteLoginExistQuery } from "../../../redux/slice/api/FO/compteApi";





const PageModifierEmailUtilisateurBO: React.FC = () => {
  //const navigate = useNavigate();
  //const dispatch = useDispatch();
  let { id } = useParams();
  id = id ?? "";

  const [checkLoginExist] = useLazyCompteLoginExistQuery();
  const {keycloak} = useKeycloak();
  
   
const { data: CompteResult} = useFetchBOCompteQuery(id, {
    refetchOnMountOrArgChange: true,
    skip: !keycloak.authenticated || id === "",
  });

  const formMethodsEmail = useForm<IEmail>({
    defaultValues: {
      EmailActuel : "",
      NouveauEmail: "",
      ConfirmationEmail: "",
    }, 
    mode: "all",
    reValidateMode: "onBlur",
    resolver: yupResolver(EmailSchema),
});

useEffect(() => {
  if (CompteResult?.Compte) {
    formMethodsEmail.reset({
      EmailActuel: CompteResult.Compte.Login,
      NouveauEmail: "",
      ConfirmationEmail: "",
    });
  }
}, [CompteResult]);
const navigate = useNavigate();
const handleToastClose = () => {
     navigate(`/admin/utilisateurmodifbo/${id}`);
   };
  const [
    updateEmail,
    ] = useCompteChangeLoginEnvoiMailBOMutation();
  
  // setValue, setError, clearErrors,getValues
  const { handleSubmit:handleSubmitEmail ,setError} =
  formMethodsEmail;

  

const onSubmitEmail: SubmitHandler<any> = async (data) => {
  if (CompteResult?.Compte?.Login?.toLowerCase() === data.EmailActuel.toLowerCase()) {
    const payload = await checkLoginExist({ 
      Login: data.NouveauEmail,
      IdCompte: CompteResult?.Compte?.Id 
    }).unwrap();
      if (payload.Exist) {
        setError("NouveauEmail", { type: "required", message: "Le nouvel email renseigné est déjà associé à un compte pour le site ''. Merci de contacter le support." }, { shouldFocus: true })
      } else {
        const EnvoiMail = await updateEmail({Login: data.EmailActuel, NewLogin: data.NouveauEmail }).unwrap();
        if (EnvoiMail.ChangementValide) {
          toast.success("Le nouvel e-mail de l’utilisateur a bien été enregistré. Merci de lui demander de vérifier sa messagerie afin de finaliser la mise à jour.", {
            onClose: handleToastClose,
          });

          
        } else {
          toast.error("Erreur lors de la modification de l'Email")
        }
      }
    
  } else {
     setError("EmailActuel", { type: "required", message: "Le mail rensigné n'est pas correcte" }, { shouldFocus: true });
  }

  };

  const onErrorEmail = (errors: any) => {

  };

return (
    <>
      <div className="container text-center">
        <div className="row pt-3 pb-5">
          <div className="col col-6 ">
            <h2 className="titreModule titre-bleu"><i className="bi-person-circle pe-2" />Modification e-mail</h2>
          </div>
        </div>
        <div className="row pt-3 pb-5">
          <div className="col col-md-6 offset-md-3 col-6 ">
          <FormProvider {...formMethodsEmail}>
            <form onSubmit={handleSubmitEmail((data) => onSubmitEmail(data),onErrorEmail)}>
              <CpntForm>
                <CpntFormSection pSectionLabel="Modification e-mail">
                      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
                      <TextInput
                          label="E-mail actuel"
                          formName="EmailActuel"
                          validationStyle={validationMode.classic}
                          placeholder="Email@exemple.com"
                          disabled
                        />
                        </CpntFormSectionContainer>
                        <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
                        <TextInput
                          label="Nouvel e-mail"
                          formName="NouveauEmail"
                          validationStyle={validationMode.classic}
                          placeholder="Email@exemple.com"
                        />
                        </CpntFormSectionContainer>
                        <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
                        <TextInput
                          label="Confirmation du nouvel e-mail"
                          formName="ConfirmationEmail"
                          validationStyle={validationMode.classic}
                          placeholder="Email@exemple.com"
                        />
                        </CpntFormSectionContainer>
                        <div></div>
                      <CpntFormSectionNavigation>
                        {/* <div></div> */}
                        <Button type="submit" className="col-4 btn-secondary">
                          Enregistrer
                        </Button>
                        {/* <div></div> */}
                      </CpntFormSectionNavigation>

                </CpntFormSection>
              </CpntForm>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
    <div>
  <p>
    <b style={{ color: 'red' }}>
     Un message de validation contenant un lien d’activation sera envoyé à la nouvelle adresse électronique de l’utilisateur.
    </b>
  </p>
</div>
    </>
  );
};

export default PageModifierEmailUtilisateurBO;


